import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('ReportCreateCtrl', ReportCreateCtrl);

    function ReportCreateCtrl(
        DATES,
        networkPointSearchService,
        platformSettingsService,
        Report,
        utilService
    ) {
        var vm = this;
        vm.DATES = DATES;
        vm.INPUT_ADDON = networkPointSearchService.INPUT_ADDON;
        vm.uiLoadingMapPins = false;
        vm.isRuntimeValid = true;
        vm.isActivityValid = true;
        vm.isRuntimeUnderYear = true;
        vm.isLastActivityValid = true;
        vm.submittingCreateReport = false;
        vm.errorSubmittingCreateReport = false;
        vm.errorSubmittingCreateReportMsg = '';
        vm.netPointPlaceholder = 'Enter point name or ID';
        vm.marketAreaPlaceholder = 'Enter Market Area';
        vm.tsoPlaceholder = 'Enter Tso';
        vm.reportScopes = {
            AUCTION: 'Short- and long term auctions',
            REVERSE_AUCTION: 'Reverse auctions',
            SURRENDER: 'Surrenders',
            FCFS: 'FCFS bookings',
            SECONDARY: 'Secondary tradings'
        };
        vm.data = {
            runtimeObj: utilService.getRunTimeSuggestion('MONTH'),
            lastActivity: utilService.getRunTimeSuggestion('MONTH'),
            marketAreas: [],
            tsos: []
        };
        vm.tsoNames = [];
        vm.marketAreas = [];
        vm.exportReport = exportReport;
        vm.submitSelectNetworkPoints = submitSelectNetworkPoints;
        vm.submitSelectMarketAreas = submitSelectMarketAreas;
        vm.submitSelectTsos = submitSelectTsos;
        vm.checkMaximum = checkMaximum;

        function exportReport(form: ng.IFormController): boolean {
            vm.isRuntimePresent = !(
                isNaN(Date.parse(vm.data.runtimeObj.start)) &&
                isNaN(Date.parse(vm.data.runtimeObj.end))
            );

            vm.isLastActivityPresent = !(
                isNaN(Date.parse(vm.data.lastActivity.start)) &&
                isNaN(Date.parse(vm.data.lastActivity.end))
            );

            if (!form.$valid || !vm.isLastActivityPresent) {
                return false;
            }

            vm.isLastActivityValid =
                vm.data.lastActivity.end <=
                new Date(
                    new Date(vm.data.lastActivity.start).setMonth(
                        vm.data.lastActivity.start.getMonth() + 3
                    )
                );
            vm.isRuntimeUnderYear =
                !vm.isRuntimePresent ||
                vm.data.runtimeObj.end <=
                    new Date(
                        new Date(vm.data.runtimeObj.start).setFullYear(
                            vm.data.runtimeObj.start.getFullYear() + 1
                        )
                    );
            if (!vm.isRuntimeUnderYear || !vm.isLastActivityValid) {
                return false;
            }

            var fileType = [];
            if (vm.data.CSV) {
                fileType.push('CSV');
            }

            if (vm.data.XLSX) {
                fileType.push('XLSX');
            }

            var param = {
                transactionType: vm.data.transactionType,
                marketArea: vm.data.marketAreas,
                tso: vm.data.tsos,
                networkPoint: vm.data.networkpoint,
                productRuntimeFrom: vm.data.runtimeObj.start,
                productRuntimeTo: vm.data.runtimeObj.end,
                activityFrom: vm.data.lastActivity.start,
                activityTo: vm.data.lastActivity.end,
                fileType: fileType
            };

            Report.createReport(
                param,
                function () {
                    vm.submittingCreateReport = true;
                    vm.errorSubmittingCreateReport = false;
                },
                function (err) {
                    const errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.';
                    vm.errorSubmittingCreateReportMsg = errorMessage;
                    vm.errorSubmittingCreateReport = true;
                    vm.submittingCreateReport = false;
                }
            );
            return true;
        }

        function submitSelectNetworkPoints(selectedNetworkPoints) {
            vm.data.networkpoint =
                platformSettingsService.extractIdsOfNetworkPoints(
                    selectedNetworkPoints
                );

            return true;
        }

        function submitSelectMarketAreas(selectedMarketAreas) {
            vm.data.marketAreas = extractNameOfMarketAreas(selectedMarketAreas);

            return true;
        }

        function submitSelectTsos(selectedTsos) {
            vm.data.tsos = extractIdAndNameOfTsos(selectedTsos);

            return true;
        }

        function extractIdAndNameOfTsos(tsos) {
            var newTsoIds = [];
            for (var i = 0; i < tsos.length; i++) {
                newTsoIds.push(tsos[i].id);
                vm.tsoNames.push(tsos[i].name);
                if (tsos[i].marketAreaNames.length > 0) {
                    angular.forEach(
                        tsos[i].marketAreaNames,
                        function (marketArea) {
                            if (vm.marketAreas.indexOf(marketArea) === -1) {
                                vm.marketAreas.push(marketArea);
                            }
                        }
                    );
                }
            }
            return newTsoIds;
        }

        function extractNameOfMarketAreas(marketAreas) {
            var newMarketAreasNames = [];
            for (var i = 0; i < marketAreas.length; i++) {
                newMarketAreasNames.push(marketAreas[i].name);
            }
            return newMarketAreasNames;
        }

        function checkMaximum(type) {
            //prevent runtime > 365 days
            if (
                vm.data.runtimeObj.start &&
                vm.data.runtimeObj.end &&
                moment(vm.data.runtimeObj.end).diff(
                    moment(vm.data.runtimeObj.start),
                    'days'
                ) > 365
            ) {
                vm.runtimeAdjusted = true;
                if (type == 'start') {
                    vm.data.runtimeObj.end = moment(vm.data.runtimeObj.start)
                        .add(365, 'Days')
                        .toDate();
                }
                if (type == 'end') {
                    vm.data.runtimeObj.start = moment(vm.data.runtimeObj.end)
                        .subtract(365, 'Days')
                        .toDate();
                }
            }
            //prevent end before start
            if (
                vm.data.runtimeObj.start &&
                vm.data.runtimeObj.end &&
                moment(vm.data.runtimeObj.end).diff(
                    moment(vm.data.runtimeObj.start),
                    'days'
                ) < 0
            ) {
                if (type == 'start') {
                    vm.data.runtimeObj.end = moment(
                        vm.data.runtimeObj.start
                    ).toDate();
                }
                if (type == 'end') {
                    vm.data.runtimeObj.start = moment(
                        vm.data.runtimeObj.end
                    ).toDate();
                }
            }
        }
    }
})();
